// generated by the plop

import { UUID } from 'symbols';
import {
  CreateStorageLocationModel,
  MoveStorageModel,
  NomenclatureModel, StorageLocationModel,
  StorageLocationTreeModel
} from '../../symbols';

export class GetStorageLocation {
  static type = '[storageLocation] GetStorageLocation';

  constructor(public folderId?: UUID) {
  }
}

export class GetAllStorageLocation {
  static type = '[storageLocation] GetAllStorageLocation';
}

export class GetGoods {
  static type = '[storageLocation] GetGoods';

  constructor(public search?: string, public onlyUsed?: boolean) {
  }
}


export class SelectGoods {
  static type = '[storageLocation] SelectGoods';

  constructor(public goods: NomenclatureModel) {
  }
}

export class CreateStorageItem {
  static type = '[storageLocation] CreateStorageItem';

  constructor(public item: NomenclatureModel) {
  }
}

export class CreateStorageItemSuccess {
  static type = '[storageLocation] CreateStorageItemSuccess';

  constructor(public item: NomenclatureModel) {
  }
}

export class CreateStorageItemFail {
  static type = '[storageLocation] CreateStorageItemFail';

  constructor(public error: unknown) {
  }
}

export class UpdateStorageItem {
  static type = '[storageLocation] UpdateStorageItem';

  constructor(public id: UUID, public item: NomenclatureModel) {
  }
}

export class UpdateStorageItemSuccess {
  static type = '[storageLocation] UpdateStorageItemSuccess';

  constructor(public item: NomenclatureModel) {
  }
}

export class UpdateStorageItemFail {
  static type = '[storageLocation] UpdateStorageItemFail';

  constructor(public error: unknown) {
  }
}

export class MoveStorageItem {
  static type = '[storageLocation] MoveStorageItem';

  constructor(public data: MoveStorageModel) {
  }
}


export class MoveStorageItemSuccess {
  static type = '[storageLocation] MoveStorageItemSuccess';

  constructor(public data: StorageLocationTreeModel) {
  }
}

export class MoveStorageItemFail {
  static type = '[storageLocation] MoveStorageItemFail';

  constructor(public error: unknown) {
  }
}

export class CreateStorageLocation {
  static type = '[storageLocation] CreateStorageLocation';

  constructor(public item: CreateStorageLocationModel) {
  }
}

export class CreateStorageLocationSuccess {
  static type = '[storageLocation] CreateStorageLocationSuccess';

  constructor(public item: StorageLocationModel) {
  }
}

export class CreateStorageLocationFail {
  static type = '[storageLocation] CreateStorageLocationFail';

  constructor(public error: unknown) {
  }
}


export class UpdateStorageLocation {
  static type = '[storageLocation] UpdateStorageLocation';

  constructor(public id: UUID, public item: CreateStorageLocationModel) {
  }
}

export class UpdateStorageLocationSuccess {
  static type = '[storageLocation] UpdateStorageLocationSuccess';

  constructor(public item: StorageLocationModel) {
  }
}

export class UpdateStorageLocationFail {
  static type = '[storageLocation] UpdateStorageLocationFail';

  constructor(public error: unknown) {
  }
}
